import { type CategoryWithChildren, type CategoryTreeItem } from './CategoryTreeMobileFirst';

/**  A function to build a tree structure of SERP categories */
export const buildSerpCategoryTree = (flatCategories: CategoryTreeItem[]) => {
  const roots: CategoryWithChildren[] = [];
  const stack: Array<{ level: number; node: CategoryWithChildren }> = [];

  for (const category of flatCategories) {
    const node: CategoryWithChildren = { ...category, children: [] };

    while (stack.length > 0 && stack[stack.length - 1].level >= category.level) {
      stack.pop();
    } // Pop until we find the parent level

    if (stack.length === 0) {
      // No parent, this is a root node
      roots.push(node);
    } else {
      const parent = stack[stack.length - 1].node;
      parent.children.push(node);
    }
    stack.push({ level: category.level, node });
  }

  return roots;
};
